import cloner from '../../utils/Cloner';
class HttpClientAuthorizer {
  authorizeRequestConfig(KeycloakIDPAdapter, requestConfig) {
    const accessToken = KeycloakIDPAdapter.getToken();
    if (!accessToken) {
      return requestConfig;
    }
    const newRequestConfig = cloner.clone(requestConfig);
    newRequestConfig.headers = {
      authorization: `Bearer ${accessToken}`
    };
    return newRequestConfig;
  }
  authorizeRequestBenchmarkingConfig(KeycloakIDPAdapter, requestConfig) {
    const client = KeycloakIDPAdapter.getClient();
    if (!client) {
      return requestConfig;
    }
    const newRequestConfig = cloner.clone(requestConfig);
    newRequestConfig.headers = {
      ...newRequestConfig.headers,
      authorization: `Bearer ${client.idToken}`
    };
    return newRequestConfig;
  }
}
const httpClientAuthorizer = new HttpClientAuthorizer();
export default httpClientAuthorizer;